import React, { Fragment, useState } from 'react';
import { Form, Message} from 'components/lib';

export function ContactForm(props){

  const [sent, setSent] = useState(false);

  return (
    <Fragment>

      { sent ? 
        <Message
          title='Mensaje enviado'
          type='success'
          text={ `Gracias por tu mensaje, nos pondremos en contacto contigo a la brevedad.` }
        />  :

        <Form 
          data={{ 
            name: {
              label: 'Tu nombre',
              type: 'text',
              required: true,
              errorMessage: 'Por favor, ingresa tu nombre'
            },
            email: {
              label: 'Tu correo electrónico',
              type: 'email',
              required: true,
              errorMessage: 'Por favor, ingresa tu correo electrónico'
            },
            message: {
              label: 'Mensaje',
              type: 'textarea',
              required: true,
              errorMessage: 'Por favor, ingresa tu mensaje'
            } 
          }}
          method='POST'
          url='/api/utility/mail'
          callback={ e => setSent(true) }
          buttonText='Enviar mensaje'
         />
       }
     </Fragment>
  );
}
